import { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { UNIQUE_OWNER } from '../constants'
import { getSelectOptions } from '../get-select-options'
import type { AbsenceTenantSelectionProps } from '../types'

export const useAbsenceTenantSelection = ({
  modulePersonIds: personsIds,
  formFields,
  formErrors,
  getTenantOptions,
  handlePersonUuidChange,
}: AbsenceTenantSelectionProps) => {
  const { t } = useFavurTranslation()
  const options = getSelectOptions({ options: getTenantOptions(), t })
  const {
    personUuid: { value: personUuid },
  } = formFields
  const { personUuid: tenantSelectionError } = formErrors
  const displayTenantSelection = personsIds.length > UNIQUE_OWNER
  const setSelectedValue = (value: number) => {
    const selectedOption = options.find((option) => option.value === value)

    if (!selectedOption) return

    handlePersonUuidChange(selectedOption.key)
  }
  const selectedValue = useMemo(() => options.find((option) => option.key === personUuid)?.value, [personUuid, options])

  return {
    tenantSelectionError,
    displayTenantSelection,
    options,
    selectedValue,
    setSelectedValue,
    t,
  }
}
